import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAlignCenter,
  faAlignLeft,
  faAlignRight,
  faAngleRight,
  faAngleDown,
  faArrowCircleLeft,
  faArrowCircleRight,
  faArrowsAlt,
  faArrowUp,
  faArrowDown,
  faArrowRight,
  faArrowLeft,
  faBabyCarriage,
  faBars,
  faBirthdayCake,
  faCandyCane,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faCaretDown,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faClipboard,
  faCloudUploadAlt,
  faCog,
  faCompressAlt,
  faCrosshairs,
  faEdit,
  faEllipsisV,
  faExchangeAlt,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faFilm,
  faFolder,
  faFolderOpen,
  faFolderPlus,
  faGifts,
  faGlassCheers,
  faGraduationCap,
  faImage,
  faInfoCircle,
  faLock,
  faMinusSquare,
  faPlus,
  faPlusSquare,
  faPencilAlt,
  faQuestionCircle,
  faRetweet,
  faRedo,
  faRuler,
  faRulerCombined,
  faSearch,
  faSignOutAlt,
  faShare,
  faShoppingCart,
  faSlidersH,
  faSquare as faSquareSolid,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUnlock,
  faUserCircle,
  faUserPlus,
  faWandMagicSparkles,
} from '@fortawesome/free-solid-svg-icons';

import {
  faCheckSquare as faCheckSquareReg,
  faCheckCircle as faCheckCircleReg,
  faCircle,
  faCopy,
  faSquare,
} from '@fortawesome/free-regular-svg-icons';

export default function initFontAwesome() {
  library.add(
    faAlignCenter,
    faAlignLeft,
    faAlignRight,
    faAngleRight,
    faAngleDown,
    faArrowCircleLeft,
    faArrowCircleRight,
    faArrowsAlt,
    faArrowUp,
    faArrowDown,
    faArrowRight,
    faArrowLeft,
    faBabyCarriage,
    faBars,
    faBirthdayCake,
    faCandyCane,
    faCaretLeft,
    faCaretRight,
    faCaretUp,
    faCaretDown,
    faCheck,
    faCheckCircle,
    faCheckCircleReg,
    faCheckSquare,
    faCheckSquareReg,
    faChevronUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faCircle,
    faClipboard,
    faCloudUploadAlt,
    faCog,
    faCompressAlt,
    faCopy,
    faCrosshairs,
    faEdit,
    faEllipsisV,
    faExchangeAlt,
    faExclamationCircle,
    faExclamationTriangle,
    faExternalLinkAlt,
    faEye,
    faFilm,
    faFolder,
    faFolderOpen,
    faFolderPlus,
    faGifts,
    faGlassCheers,
    faGraduationCap,
    faImage,
    faInfoCircle,
    faLock,
    faMinusSquare,
    faPlus,
    faPlusSquare,
    faPencilAlt,
    faQuestionCircle,
    faRetweet,
    faRedo,
    faRuler,
    faRulerCombined,
    faSearch,
    faSignOutAlt,
    faShare,
    faShoppingCart,
    faSlidersH,
    faSquare,
    faSquareSolid,
    faTimes,
    faTimesCircle,
    faTrashAlt,
    faUnlock,
    faUserCircle,
    faUserPlus,
    faWandMagicSparkles
  );
}
